import Cookies from 'js-cookie';

export const clearCookies = () => {
  Cookies.remove('accessToken');
  Cookies.remove('refreshToken');
  Cookies.remove('sessionState');
  Cookies.remove('dealerId');
  Cookies.remove('storeId');
  Cookies.remove('role');
  Cookies.remove('userType');
};
